import { selectAll } from "./functionAux";

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function isInputValid(input) {
    const dataSizeCaracteres = 'data-min-caracteres';
    const minLength = input.value.length >= +input.getAttribute(dataSizeCaracteres);

    if (input.type === 'email' || input.dataset.mask === 'email') {
        return minLength && isValidEmail(input.value);
    }

    return minLength;
}

export default function valideInputsTextForms(form) {
    const inputsForm = selectAll(`${form} [data-min-caracteres]`);

    inputsForm.forEach(input => {
        if(isInputValid(input)) {
            input.parentElement.classList.remove('error');
            input.classList.remove('error');
        } else {
            input.parentElement.classList.add('error');
            input.classList.add('error');
        }
    })

    return Array.from(inputsForm).every(input => isInputValid(input));
};
